export default class Accordeon {
  constructor(element) {
    this.element = element;
    this.options = {
      active: false,
      alwaysOpen: false,
    };
    this.init();
  }
  init() {
    this.setOptions();
    if (!this.options.alwaysOpen) {
      this.element.addEventListener('click', this.toggle.bind(this));
    }
  }

  setOptions() {
    // data-start-open
    if ('startOpen' in this.element.dataset) {
      this.options.active = true;
      this.element.classList.add('is-open');
    }
    // data-always-open
    if ('alwaysOpen' in this.element.dataset) {
      this.options.alwaysOpen = true;
    }
  }

  toggle() {
    const newState = this.element.classList.toggle('is-open');
    this.options.active = newState;
  }
}
